import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import CheckboxInput from './checkboxInput';

type MutliSelectCheckboxOption = {
  label?: string;
  value?: string | number;
  disabled?: boolean;
};

export type MutliSelectCheckboxProps = {
  className?: string;
  label?: string;
  options: MutliSelectCheckboxOption[];
  // PropTypes declares this as a required string, but the component calls
  // value.includes(...) below, so it's actually an array at runtime — pre-existing.
  value: (string | number)[];
  onChange: (
    name: string | undefined,
    value: string | number | undefined,
    checked: boolean,
  ) => void;
  disabled?: boolean;
};

const MutliSelectCheckbox = ({
  className,
  label = '',
  options,
  value,
  onChange,
  disabled = false,
}: MutliSelectCheckboxProps) => (
  <div className={classnames('custom-select-checkbox', className)}>
    {!!label && <div className="custom-dropdown-input__label">{label}</div>}
    <div className="body">
      {_.map(options, (d, index) => (
        <CheckboxInput
          id={`checkbox-${index}`}
          name="fax-report"
          data={{
            label: d.label,
            value: d.value,
          }}
          checked={value.includes(d.value as any)}
          onChange={onChange}
          disabled={d.disabled || disabled}
        />
      ))}
    </div>
  </div>
);

export default MutliSelectCheckbox;
